import { lazy, useEffect } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "components/Loadable";
import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";
import {} from "helper/permissionsCheck";
import GriReporting from "pages/gri/GriReporting";
import WhatIsGri from "pages/gri/WhatIsGri";
import CustomizedGriStandards from "pages/gri/reportingWithGriStandards/CustomizedGriStandards";

import MaterialByEsgTopics from "pages/gri/reportingWithGriStandards/MaterialByEsgTopics";
import ReportingWithGriStandards from "pages/gri/ReportingWithGriStandards";
import AiAutoSelection from "pages/gri/reportingWithGriStandards/AiAutoSelection";
import SasbReporting from "pages/sasb/SasbReporting";
import WhatisSasb from "pages/sasb/WhatisSasb";
import IndustrySpecificSASBDisclosures from "pages/sasb/IndustrySpecificSASBDisclosures";
import IndustrySpecific from "pages/sasb/industrySpecificDisclosures/IndustrySpecific";
import SasbDisclosureByCategory from "pages/sasb/industrySpecificDisclosures/SasbDisclosureByCategory";
import AutoSelectWithAi from "pages/sasb/industrySpecificDisclosures/AutoSelectWithAi";
import TcdfReporting from "pages/tcfd/TcfdReporting";
import TcfdReporting from "pages/tcfd/TcfdReporting";
import WhatisTcfd from "pages/tcfd/WhatisTcfd";
import ClimateRelatedFinancial from "pages/tcfd/ClimateRelatedFinancial";
import ClimateRelatedFinancialDis from "pages/tcfd/climateRelatedFinancialDis/ClimateRelatedFinancialDis";
import AutoSelectAITcfd from "pages/tcfd/climateRelatedFinancialDis/AutoSelectAITcfd";
import IfrsReporting from "pages/ifrs/IfrsReporting";
import WhatsisIfrs from "pages/ifrs/WhatsisIfrs";
import SustainabilityAndClimatedDoc from "pages/ifrs/SustainabilityAndClimatedDoc";
import IFRS_S1SustainabilityrelFclDis from "pages/ifrs/sustainibilityAndClimateDocument/IFRS_S1SustainabilityrelFclDis";
import IFRS_S2ClimateRelDiscl from "pages/ifrs/sustainibilityAndClimateDocument/IFRS_S2ClimateRelDiscl";
import AutoSelectAI_Ifrs from "pages/ifrs/sustainibilityAndClimateDocument/AutoSelectAI_Ifrs";
import AutoSelectWithAI_S1 from "pages/ifrs/sustainibilityAndClimateDocument/AutoSelectWithAI_S1";
import AutoSelectWithAi_S2 from "pages/ifrs/sustainibilityAndClimateDocument/AutoSelectWithAi_S2";
import CSRD_ESRSReporting from "pages/csrd_esrs(eu)/CSRD_ESRSReporting";
import WhatIsCsrd from "pages/csrd_esrs(eu)/WhatIsCsrd";
import WhatisEsrs from "pages/csrd_esrs(eu)/WhatisEsrs";
import DoubleMateriality from "pages/csrd_esrs(eu)/DoubleMateriality";
import CorporateSustainability from "pages/csrd_esrs(eu)/CorporateSustainability";
import CSRDReportingESRDStandards from "pages/csrd_esrs(eu)/corportateSustainability/CSRDReportingESRDStandards";
import AutoSelectAICsrd from "pages/csrd_esrs(eu)/corportateSustainability/AutoSelectAICsrd";
import UngcReporting from "pages/ungc/UngcReporting";
import WhatisUngc from "pages/ungc/WhatisUngc";
import UngcPrincipleCompliance from "pages/ungc/UngcPrincipleCompliance";
import PrincipleComplianceCustomize from "pages/ungc/ungcPrincipleCompliance/PrincipleComplianceCustomize";
import IndustrialIdentificationWithNature from "pages/fieldObservations/industrialidentification";
import AutoSelectAIUngc from "pages/ungc/ungcPrincipleCompliance/AutoSelectAIUngc";
import SdgReporting from "pages/sdg/SdgReporting";
import WhatisSdg from "pages/sdg/WhatisSdg";
import SdgCompliance from "pages/sdg/SdgCompliance";
import SdgGoalsComplCustomizeTopic from "pages/sdg/sdgCompliance/SdgGoalsComplCustomizeTopic";
import SdgComplianceCustomTarget from "pages/sdg/sdgCompliance/SdgComplianceCustomTarget";
import AutoSelectAiSdg from "pages/sdg/sdgCompliance/AutoSelectAiSdg";
import CdpReporting from "pages/cdp/CdpReporting";
import WhatisCdp from "pages/cdp/WhatisCdp";
import CdpCompliance from "pages/cdp/CdpCompliance";
import CdpComplianceCustomization from "pages/cdp/cdpCompliance/CdpComplianceCustomization";
import AutoSelectAiCdp from "pages/cdp/cdpCompliance/AutoSelectAiCdp";
import WbReporting from "pages/wb/WbReporting";
import WhatisWb from "pages/wb/WhatisWb";
import WbCompliances from "pages/wb/WbCompliances";
import WbComplianceCustom from "pages/wb/wbCompliance/WbComplianceCustom";
import AutoSelectWb from "pages/wb/wbCompliance/AutoSelectWb";
import IfcPSs from "pages/ifcPSs/IfcPSs";
import WhatisIfcPSs from "pages/ifcPSs/WhatisIfcPSs";
import IfcCompliance from "pages/ifcPSs/IfcCompliance";
import IfcComplianceCustom from "pages/ifcPSs/ifcCompliance/IfcComplianceCustom";
import IfcAutoSelecAi from "pages/ifcPSs/ifcCompliance/IfcAutoSelecAi";
import EquatorPrincipleReporting from "pages/equatorPrinciple/EquatorPrincipleReporting";
import WhatareEP from "pages/equatorPrinciple/WhatareEP";
import EpCompliance from "pages/equatorPrinciple/EpCompliance";
import EpComplianceCustom from "pages/equatorPrinciple/epCompliance/EpComplianceCustom";
import EpAutoSelectAI from "pages/equatorPrinciple/epCompliance/EpAutoSelectAI";
import IsoStandReporting from "pages/isoStandards/IsoStandReporting";
import WhatisIso from "pages/isoStandards/WhatisIso";
import IsoCompliance from "pages/isoStandards/IsoCompliance";
import IsoComplianceCustom from "pages/isoStandards/isoCompliance/IsoComplianceCustom";
import IsoAutoSelectAi from "pages/isoStandards/isoCompliance/IsoAutoSelectAi";
import OecdGuidelines from "pages/oecd/OecdGuidelines";
import WhatAreOecdGuide from "pages/oecd/WhatAreOecdGuide";
import OecdCompliance from "pages/oecd/OecdCompliance";
import OecdComplianceCustom from "pages/oecd/oecdCompliance/OecdComplianceCustom";
import OecdAutoSelectAi from "pages/oecd/oecdCompliance/OecdAutoSelectAi";
import TnfdReporting from "pages/tnfd/TnfdReporting";
import WhatIsTnfd from "pages/tnfd/WhatIsTnfd";
import TnfdCompliance from "pages/tnfd/TnfdCompliance";
import TnfdComplianceCustom from "pages/tnfd/tnfdCompliance/TnfdComplianceCustom";
import TnfdAutoSelectAi from "pages/tnfd/tnfdCompliance/TnfdAutoSelectAi";
import AaSeriesReporting from "pages/aa10000Series/AaSeriesReporting";
import WhatIsAA1000Series from "pages/aa10000Series/WhatIsAA1000Series";
import AA1000SeriesCompliance from "pages/aa10000Series/AA1000SeriesCompliance";
import AA1000SeriesCustom from "pages/aa10000Series/aaSeriesCompliance/AA1000SeriesCustom";
import AASeriesAiAutoSelect from "pages/aa10000Series/aaSeriesCompliance/AASeriesAiAutoSelect";
import PriPrincipleReporting from "pages/priPrinciple/PriPrincipleReporting";
import WhatArePriPrinciple from "pages/priPrinciple/WhatArePriPrinciple";
import PriPrincipleCompliance from "pages/priPrinciple/PriPrincipleCompliance";
import PriPrincipleCustom from "pages/priPrinciple/priPrincipleCompliance/PriPrincipleCustom";
import PriPrincipleAIAutoSelect from "pages/priPrinciple/priPrincipleCompliance/PriPrincipleAIAutoSelect";
import IrisGiinReporting from "pages/iris/IrisGiinReporting";
import WhatisIrisGiin from "pages/iris/WhatisIrisGiin";
import IrisGiinComplianceMatrix from "pages/iris/IrisGiinComplianceMatrix";
import IrisSystemCompMatrix from "pages/iris/irisCompliance/IrisSystemCompMatrix";
import IRISSystemKpiProjEntities from "pages/iris/irisCompliance/IRISSystemKpiProjEntities";
import IrisAutoSelectAI from "pages/iris/irisCompliance/IrisAutoSelectAI";
import EmissionTracking from "pages/ghgEmissionMang/EmissionTracking";
import GhgEmissionsMangement from "pages/ghgEmissionMang/GhgEmissionsMangement";
import EmissionsTrackAI from "pages/ghgEmissionMang/EmissionsTrackAI";
import ClimateImpactAssesReporting from "pages/climateImpactAssesment/ClimateImpactAssesReporting";
import CarbonOffset from "pages/carbonOffsetting/CarbonOffset";
import CarbonOffsetCreditMang from "pages/carbonOffsetting/CarbonOffsetCreditMang";
import CarbonOffsetMangAi from "pages/carbonOffsetting/CarbonOffsetMangAi";
import SustainabilityBondStanReports from "pages/sustainableFinanceBondStandards/SustainabilityBondStanReports";
import EsgBondCompliance from "pages/sustainableFinanceBondStandards/EsgBondCompliance";
import AIAutoSelectEsgBond from "pages/sustainableFinanceBondStandards/AIAutoSelectEsgBond";
import HseAuditToolStepper from "pages/hseAuditTool/HseAuditToolStepper";
import EnviromentalComplianceStepper from "pages/enviromentalComplianceReporting/EnviromentalComplianceStepper";
import SocialComplianceReporting from "pages/socialCompliance/SocialComplianceReporting";
import UniversalRiskAssessGenStepper from "pages/universalRiskAssessmentGen.jsx/UniversalRiskAssessGenStepper";
import SurveyMonitorTrackTool from "pages/surveyMonitorTrackingTool/SurveyMonitorTrackTool";
import ESLegalApplicationReq from "pages/legalAndAppReq/ESLegalApplicationReq";
import EsSocialSystemDevelopment from "pages/esSocialSystemDev/EsSocialSystemDevelopment";
import TrainingCapacityBuilProgram from "pages/trainingCapacityBuilding/TrainingCapacityBuilProgram";
import UpcomingFeaturesStepper from "pages/upComingFeatures/UpcomingFeaturesStepper";
import SupplierAssessmentSelectModule from "pages/supplierAssessmentSelectMod/SupplierAssessmentSelectModule";
import EsgAnalyticsStepper from "pages/esgAnalytics/EsgAnalyticsStepper";
import EsgAnalyticsAI from "pages/esgAnalytics/EsgAnalyticsAI";
import AllEsgAnalytics from "pages/esgAnalytics/AllEsgAnalytics";
import EsgBenchMarkingStepper from "pages/esgBenchMarking/EsgBenchMarkingStepper";
import SectorSpecificStandardCompliances from "pages/sectorSpecificStandard/SectorSpecificStandardCompliances";
import SectorStandardCompliance from "pages/sectorSpecificStandard/SectorStandardCompliance";
import AutoSelectAISector from "pages/sectorSpecificStandard/AutoSelectAISector";
import OperationalCompliaceReporting from "pages/operational/OperationalCompliaceReporting";
import CountrySpecificCompliance from "pages/countrySpecificEsg/CountrySpecificCompliance";
import Canada from "pages/countrySpecificEsg/countries/Canada";
import EsDueDiligenceCompliance from "pages/esDilligence/EsDueDiligenceCompliance";
import UnitedArabEmirates from "pages/countrySpecificEsg/countries/UnitedArabEmirates";
import France from "pages/countrySpecificEsg/countries/France";
import Germany from "pages/countrySpecificEsg/countries/Germany";
import Italy from "pages/countrySpecificEsg/countries/Italy";
import Netherlands from "pages/countrySpecificEsg/countries/Netherlands";
import Spain from "pages/countrySpecificEsg/countries/Spain";
import Pakistan from "pages/countrySpecificEsg/countries/Pakistan";
import Bangladesh from "pages/countrySpecificEsg/countries/Bangladesh";
import Nigeria from "pages/countrySpecificEsg/countries/Nigeria";
import Singapore from "pages/countrySpecificEsg/countries/Singapore";
import Malaysia from "pages/countrySpecificEsg/countries/Malaysia";
import Indonesia from "pages/countrySpecificEsg/countries/Indonesia";
import Vietnam from "pages/countrySpecificEsg/countries/Vietnam";
import Thailand from "pages/countrySpecificEsg/countries/Thailand";
import Philippines from "pages/countrySpecificEsg/countries/Philippines";
import CountryAutoSelectAI from "pages/countrySpecificEsg/countries/CountryAutoSelectAI";
import ReferanceSources from "pages/sustainableFinanceBondStandards/ReferanceSources";
import FieldObservation from "pages/fieldObservations/esTools/FieldObservation";
import WalkThroughInspections from "pages/fieldObservations/esTools/WalkThroughInspection";
import FieldsNotes from "pages/fieldObservations/esTools/FieldsNotes";
import MinutesOfMeeting from "pages/fieldObservations/esTools/MinutesOfMeeting";
import HazardIdentification from "pages/fieldObservations/esTools/hazardIdentification";
import Environmental_Monitoring from "pages/fieldObservations/esTools/Environmental_Monitoring";
import Noise_Monitoring from "pages/fieldObservations/esTools/Noise_Monitoring";
import AirQualityMonitoring from "pages/fieldObservations/esTools/Air_Quality_Monitoring";
import WaterAndWastewaterMonitoring from "pages/fieldObservations/esTools/water_&_wastewater_monitoring";
import WasteandSpillTracking from "pages/fieldObservations/esTools/Waste_&_Spill _Tracking";
import BiodiversityandHabitatChecks from "pages/fieldObservations/esTools/Biodiversity&HabitatChecks";
import LandUseSoilDisturbance from "pages/fieldObservations/esTools/LandUseSoilDisturbance";
import StakeholderMeetings from "pages/fieldObservations/esTools/StakeholderMeetings";
import CommunityComplaintsAndGrievances from "pages/fieldObservations/esTools/CommunityComplaintsandGrievances";
import TrainingAndToolbox from "pages/fieldObservations/esTools/TrainingAndToolboxTalks";
import ContractorAndSubcontractorCompliance from "pages/fieldObservations/esTools/ContractorAndSubcontractorCompliance";
import PermitAndPPEChecks from "pages/fieldObservations/esTools/Permit-to-Work(PTW)AndPPEChecks";
import IncidentAndNearMissReporting from "pages/fieldObservations/esTools/IncidentAndNearMissReporting";
import EmergencyDrillTracker from "pages/fieldObservations/esTools/EmergencyDrillTracker";
import AssetAndEquipmentInspections from "pages/fieldObservations/esTools/AssetAndEquipmentInspections";
import ESGVerificationModule from "pages/verificationModle/esgverificationmodule";
import VerificationDashboard from "pages/verificationModle/VerificationDash";
import IRISComponentsTable from "components/customizedStandardsComponent/IRISIntroComponent/IRISComponentsTable";
import IRISGlossaryTable from "components/customizedStandardsComponent/IRISIntroComponent/IRISGlossaryTable";
import IRISReferenceLists from "components/customizedStandardsComponent/IRISIntroComponent/IRISReferenceLists";
import MetricsCatalogTable from "components/customizedStandardsComponent/IRISIntroComponent/MetricsCatalogTable";

const DashboardDefault = Loadable(lazy(() => import("pages/dashboard")));
const AlllAssigPermissions = Loadable(
  lazy(() => import("pages/assignpermission/allassingpermissions"))
);
const CreateAssignPermission = Loadable(
  lazy(() => import("pages/assignpermission/createassignpermission"))
);
const AllAssPremiDetails = Loadable(
  lazy(() => import("pages/assignpermission/allassigndetails"))
);
const AllRoles = Loadable(lazy(() => import("pages/roles/allroles")));
const RegisterUser = Loadable(
  lazy(() => import("pages/user-management/registerUser"))
);

const PermissionsAssign = Loadable(
  lazy(() => import("pages/permissions/assign"))
);
const AllUsers = Loadable(lazy(() => import("pages/user-management/allusers")));
// ==============================|| MAIN ROUTES ||============================== //
// let permissionUser = localStorage.getItem('LoginData');
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    localStorage.clear();
    window.location.reload();
  }
}

const permissionsAssrray =
  decryptedData && JSON.parse(decryptedData)?.user_type;

// useEffect(() => {
//   window.location.href = "/payments/all-payments";
// }, [permissionsAssrray]);

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <MainLayout />,
      children:
        permissionsAssrray == "bank_user"
          ? []
          : [
              {
                path: "/",
                element: <DashboardDefault />,
              },
              {
                path: "dashboard",
                element: <DashboardDefault />,
              },
              {
                path: "*",
                element: <DashboardDefault />,
              },
            ],
    },
    {
          path: "roles",
          element: <MainLayout />,
          children: [
            {
                  path: "all-roles",
                  element: <AllRoles />,
                },
          ],
        },

    {
          path: "permissions",
          element: <MainLayout />,
          children: [
            {
                  path: "all-permissions",
                  element: <PermissionsAssign />,
                },
          ],
        },

    {
          path: "users",
          element: <MainLayout />,
          children: [
            {
                  path: "all-users",
                  element: <AllUsers />,
                },
          ],
        },

    {
          path: "users",
          element: <MainLayout />,
          children: [
            {
                  path: "register-users",
                  element: <RegisterUser />,
                },
          ],
        },

    {
          path: "reporting",
          element: <MainLayout />,
          children: [
            {
                  path: "gri",
                  element: <GriReporting />,
                },
            {
                  path: "gri/whatisgri",
                  element: <WhatIsGri />,
                },
            {
                  path: "gri/gri-standard-reporting",
                  element: <ReportingWithGriStandards />,
                },
            {
                  path: "gri/gri-standard-reporting/customized-gri-standards",
                  element: <CustomizedGriStandards />,
                },
            {
                  path: "gri/gri-standard-reporting/auto-select-ai",
                  element: <AiAutoSelection />,
                },
            {
                  path: "gri/gri-standard-reporting/material-by-esg-topics",
                  element: <MaterialByEsgTopics />,
                },
            {
                  path: "tcfd",
                  element: <TcfdReporting />,
                },
            {
                  path: "tcfd/whatistcfd",
                  element: <WhatisTcfd />,
                },

            {
                  path: "tcfd/climate-related-financial-disclosure",
                  element: <ClimateRelatedFinancial />,
                },
            {
                  path: "tcfd/climate-related-financial-disclosure/climate-related-financial-disclosure",
                  element: <ClimateRelatedFinancialDis />,
                },

            {
                  path: "tcfd/climate-related-financial-disclosure/auto-select-with-ai",
                  element: <AutoSelectAITcfd />,
                },

            {
                  path: "ifrs",
                  element: <IfrsReporting />,
                },

            {
                  path: "ifrs/whatisifrs",
                  element: <WhatsisIfrs />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures",
                  element: <SustainabilityAndClimatedDoc />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures/ifrs-s1-sustainability-related-financial-disclosure",
                  element: <IFRS_S1SustainabilityrelFclDis />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures/ifrs-s2-climate-related-disclosures",
                  element: <IFRS_S2ClimateRelDiscl />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures/AutoSelectAI_Ifrs",
                  element: <AutoSelectAI_Ifrs />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures/AutoSelectWithAI_S1",
                  element: <AutoSelectWithAI_S1 />,
                },

            {
                  path: "ifrs/sustainability-and-climate-related-financial-disclosures/AutoSelectWithAI_S2",
                  element: <AutoSelectWithAi_S2 />,
                },

            {
                  path: "sasb",
                  element: <SasbReporting />,
                },
            {
                  path: "sasb/whatissasb",
                  element: <WhatisSasb />,
                },
            {
                  path: "sasb/industry_specific",
                  element: <IndustrySpecificSASBDisclosures />,
                },
            {
                  path: "sasb/industry_specific/disclosures",
                  element: <IndustrySpecific />,
                },

            {
                  path: "sasb/disclosure_category",
                  element: <SasbDisclosureByCategory />,
                },

            {
                  path: "sasb/auto-select-with-ai",
                  element: <AutoSelectWithAi />,
                },

            {
                  path: "csrd-esrs",
                  element: <CSRD_ESRSReporting />,
                },

            {
                  path: "csrd-esrs/whatiscsrd-esd-doublemateriality",
                  element: <WhatIsCsrd />,
                },
            {
                  path: "csrd-esrs/whatisesrs",
                  element: <WhatisEsrs />,
                },

            {
                  path: "csrd-esrs/double-materiality",
                  element: <DoubleMateriality />,
                },

            {
                  path: "csrd-esrs/corporate-sustainability",
                  element: <CorporateSustainability />,
                },

            {
                  path: "csrd-esrs/corporate-sustainability/csrd-reporting-esrd-standards",
                  element: <CSRDReportingESRDStandards />,
                },

            {
                  path: "csrd-esrs/corporate-sustainability/auto-selectai_csrd",
                  element: <AutoSelectAICsrd />,
                },

            {
                  path: "ungc",
                  element: <UngcReporting />,
                },

            {
                  path: "ungc/whatsisungc",
                  element: <WhatisUngc />,
                },

            {
                  path: "ungc/ungc-principle-compliance",
                  element: <UngcPrincipleCompliance />,
                },

            {
                  path: "ungc/ungc-principle-compliance/customize",
                  element: <PrincipleComplianceCustomize />,
                },

            {
                  path: "ungc/ungc-principle-compliance/autoselectai",
                  element: <AutoSelectAIUngc />,
                },

            {
                  path: "sdg",
                  element: <SdgReporting />,
                },

            {
                  path: "sdg/whatissdg",
                  element: <WhatisSdg />,
                },

            {
                  path: "sdg/sdg-compliace",
                  element: <SdgCompliance />,
                },

            {
                  path: "sdg/sdg-compliace/sdg-goals-topics",
                  element: <SdgGoalsComplCustomizeTopic />,
                },

            {
                  path: "sdg/sdg-compliace/sdg-custom-target",
                  element: <SdgComplianceCustomTarget />,
                },

            {
                  path: "sdg/sdg-compliace/auto-select-ai",
                  element: <AutoSelectAiSdg />,
                },

            {
                  path: "cdp",
                  element: <CdpReporting />,
                },

            {
                  path: "cdp/whatis-cdp",
                  element: <WhatisCdp />,
                },
            {
                  path: "cdp/compliance",
                  element: <CdpCompliance />,
                },

            {
                  path: "cdp/compliance/customization",
                  element: <CdpComplianceCustomization />,
                },

            {
                  path: "cdp/compliance/autoselect-ai",
                  element: <AutoSelectAiCdp />,
                },

            {
                  path: "wb",
                  element: <WbReporting />,
                },

            {
                  path: "wb/whatiswb",
                  element: <WhatisWb />,
                },

            {
                  path: "wb/compliance",
                  element: <WbCompliances />,
                },

            {
                  path: "wb/compliance/customization",
                  element: <WbComplianceCustom />,
                },

            {
                  path: "wb/compliance/auto-select-ai",
                  element: <AutoSelectWb />,
                },
            {
                  path: "ifc-pss",
                  element: <IfcPSs />,
                },
            {
                  path: "ifc-pss/whatis-ifc",
                  element: <WhatisIfcPSs />,
                },

            {
                  path: "ifc-pss/compliance",
                  element: <IfcCompliance />,
                },

            {
                  path: "ifc-pss/compliance/customization",
                  element: <IfcComplianceCustom />,
                },

            {
                  path: "ifc-pss/compliance/auto-select-ai",
                  element: <IfcAutoSelecAi />,
                },

            {
                  path: "equator",
                  element: <EquatorPrincipleReporting />,
                },

            {
                  path: "equator/what-are-ep",
                  element: <WhatareEP />,
                },

            {
                  path: "equator/ep-compliance",
                  element: <EpCompliance />,
                },

            {
                  path: "equator/ep-compliance/customization",
                  element: <EpComplianceCustom />,
                },

            {
                  path: "equator/ep-compliance/auto-select-ai",
                  element: <EpAutoSelectAI />,
                },

            {
                  path: "iso",
                  element: <IsoStandReporting />,
                },

            {
                  path: "iso/whatis-iso",
                  element: <WhatisIso />,
                },
            {
                  path: "iso/iso-compliance",
                  element: <IsoCompliance />,
                },

            {
                  path: "iso/iso-compliance/customization",
                  element: <IsoComplianceCustom />,
                },

            {
                  path: "iso/iso-compliance/auto-select-ai",
                  element: <IsoAutoSelectAi />,
                },

            {
                  path: "oecd-guidelines",
                  element: <OecdGuidelines />,
                },

            {
                  path: "oecd-guidelines/what-are-oecd-guide",
                  element: <WhatAreOecdGuide />,
                },

            {
                  path: "oecd-guidelines/oecd-compliance",
                  element: <OecdCompliance />,
                },

            {
                  path: "oecd-guidelines/oecd-compliance/customization",
                  element: <OecdComplianceCustom />,
                },

            {
                  path: "oecd-guidelines/oecd-compliance/auto-select-ai",
                  element: <OecdAutoSelectAi />,
                },

            {
                  path: "tnfd",
                  element: <TnfdReporting />,
                },

            {
                  path: "tnfd/what-is-tnfd",
                  element: <WhatIsTnfd />,
                },

            {
                  path: "tnfd/tnfd-compliance",
                  element: <TnfdCompliance />,
                },

            {
                  path: "tnfd/tnfd-compliance/customization",
                  element: <TnfdComplianceCustom />,
                },

            {
                  path: "tnfd/tnfd-compliance/customization/auto-select-ai",
                  element: <TnfdAutoSelectAi />,
                },

            {
                  path: "aa10000-series",
                  element: <AaSeriesReporting />,
                },
            {
                  path: "aa10000-series/what-is-aa1000-series",
                  element: <WhatIsAA1000Series />,
                },

            {
                  path: "aa10000-series/aa1000-series-compliance",
                  element: <AA1000SeriesCompliance />,
                },

            {
                  path: "aa10000-series/aa1000-series-compliance/customization",
                  element: <AA1000SeriesCustom />,
                },

            {
                  path: "aa10000-series/aa1000-series-compliance/auto-select-ai",
                  element: <AASeriesAiAutoSelect />,
                },

            {
                  path: "pri-principle",
                  element: <PriPrincipleReporting />,
                },

            {
                  path: "pri-principle/what-are-pri-principle",
                  element: <WhatArePriPrinciple />,
                },

            {
                  path: "pri-principle/pri-principle-compliance",
                  element: <PriPrincipleCompliance />,
                },

            {
                  path: "pri-principle/pri-principle-compliance/customization",
                  element: <PriPrincipleCustom />,
                },

            {
                  path: "pri-principle/pri-principle-compliance/auto-select-ai",
                  element: <PriPrincipleAIAutoSelect />,
                },

            {
                  path: "iris",
                  element: <IrisGiinReporting />,
                },
            {
                  path: "iris/whatis-iris-giin",
                  element: <WhatisIrisGiin />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix",
                  element: <IrisGiinComplianceMatrix />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-compliances-matrix",
                  element: <IrisSystemCompMatrix />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities",
                  element: <IRISSystemKpiProjEntities />,
                },
            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISComponentsTable",
                  element: <IRISComponentsTable />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISGlossaryTable",
                  element: <IRISGlossaryTable />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISReferenceLists",
                  element: <IRISReferenceLists />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/MetricsCatalogTable",
                  element: <MetricsCatalogTable />,
                },

            {
                  path: "iris/iris-giin-compliance-matrix/auto-select-ai",
                  element: <IrisAutoSelectAI />,
                },
          ],
        },

    {
          path: "carbon",
          element: <MainLayout />,
          children: [
            {
                  path: "ghg",
                  element: <GhgEmissionsMangement />,
                },
            {
                  path: "ghg/emission-tracking",
                  element: <EmissionTracking />,
                },

            {
                  path: "ghg/emissions-track-ai",
                  element: <EmissionsTrackAI />,
                },

            {
                  path: "climate-impact-assessment",
                  element: <ClimateImpactAssesReporting />,
                },

            {
                  path: "offsetting",
                  element: <CarbonOffset />,
                },

            {
                  path: "offsetting/carbon-offset-credit-management",
                  element: <CarbonOffsetCreditMang />,
                },

            {
                  path: "offsetting/carbon-offset-mang-ai",
                  element: <CarbonOffsetMangAi />,
                },

            {
                  path: "sustainable-finance-bond-standards",
                  element: <SustainabilityBondStanReports />,
                },
            {
                  path: "sustainable-finance-bond-standards/referance-sources",
                  element: <ReferanceSources />,
                },

            {
                  path: "sustainable-finance-bond-standards/esg-bond-compliance",
                  element: <EsgBondCompliance />,
                },

            {
                  path: "sustainable-finance-bond-standards/ai-auto-select-esg-bond",
                  element: <AIAutoSelectEsgBond />,
                },
          ],
        },

    {
          path: "operations",
          element: <MainLayout />,
          children: [
            {
                  path: "hse-audit-tool",
                  element: <HseAuditToolStepper />,
                },

            {
                  path: "enviromental-compliance-reporting",
                  element: <EnviromentalComplianceStepper />,
                },

            {
                  path: "social-compliance-reporting",
                  element: <SocialComplianceReporting />,
                },

            {
                  path: "universal-risk-assessment",
                  element: <UniversalRiskAssessGenStepper />,
                },

            {
                  path: "survey-monitoring-tracking-tool",
                  element: <SurveyMonitorTrackTool />,
                },

            {
                  path: "legal-and-applicability-requirements",
                  element: <ESLegalApplicationReq />,
                },
            {
                  path: "es-social-system-development",
                  element: <EsSocialSystemDevelopment />,
                },
          ],
        },

    {
          path: "development",
          element: <MainLayout />,
          children: [
            {
                  path: "training",
                  element: <TrainingCapacityBuilProgram />,
                },

            {
                  path: "upcoming-features",
                  element: <UpcomingFeaturesStepper />,
                },
          ],
        },

    {
          path: "supplier",
          element: <MainLayout />,
          children: [
            {
                  path: "assessment-select-module",
                  element: <SupplierAssessmentSelectModule />,
                },
          ],
        },

    {
          path: "analytics",
          element: <MainLayout />,
          children: [
            {
                  path: "esg-analytics",
                  element: <AllEsgAnalytics />,
                },

            {
                  path: "esg-analytics/esg-analytics-stepper",
                  element: <EsgAnalyticsStepper />,
                },
            {
                  path: "esg-analytics/esg-analytics-ai",
                  element: <EsgAnalyticsAI />,
                },

            {
                  path: "esg-benchmarking",
                  element: <EsgBenchMarkingStepper />,
                },
          ],
        },

    {
          path: "field-monitoring-application",
          element: <MainLayout />,
          children: [
            {
                  path: "industrial-identification",
                  element: <IndustrialIdentificationWithNature />,
                },
            {
                  path: "industrial-identification/field-observation",
                  element: <FieldObservation />,
                },
            {
                  path: "industrial-identification/walkthrough-inspections",
                  element: <WalkThroughInspections />,
                },
            {
                  path: "industrial-identification/fields_notes",
                  element: <FieldsNotes />,
                },
            {
                  path: "industrial-identification/minutes-of-meeting",
                  element: <MinutesOfMeeting />,
                },

            {
                  path: "industrial-identification/hazard-identification",
                  element: <HazardIdentification />,
                },

            {
                  path: "industrial-identification/environmental-monitoring",
                  element: <Environmental_Monitoring />,
                },
            {
                  path: "industrial-identification/noise-moitoring",
                  element: <Noise_Monitoring />,
                },

            {
                  path: "industrial-identification/air_quality_monitoring",
                  element: <AirQualityMonitoring />,
                },

            {
                  path: "industrial-identification/water-and-waste-monitoring",
                  element: <WaterAndWastewaterMonitoring />,
                },

            {
                  path: "industrial-identification/waste_and_spill_tracking",
                  element: <WasteandSpillTracking />,
                },

            {
                  path: "industrial-identification/biodiversity_and_habitat_checks",
                  element: <BiodiversityandHabitatChecks />,
                },

            {
                  path: "industrial-identification/land_use_soil_disturbance",
                  element: <LandUseSoilDisturbance />,
                },

            {
                  path: "industrial-identification/stakeholder_meetings",
                  element: <StakeholderMeetings />,
                },

            {
                  path: "industrial-identification/Community_Complaints_And_Grievances",
                  element: <CommunityComplaintsAndGrievances />,
                },

            {
                  path: "industrial-identification/training_and_toolbox",
                  element: <TrainingAndToolbox />,
                },

            {
                  path: "industrial-identification/Contractor_and_subcontractor_compliance",
                  element: <ContractorAndSubcontractorCompliance />,
                },

            {
                  path: "industrial-identification/Permit_to_Work_and_checks",
                  element: <PermitAndPPEChecks />,
                },

            {
                  path: "industrial-identification/incident_and_near_miss_reporting",
                  element: <IncidentAndNearMissReporting />,
                },

            {
                  path: "industrial-identification/emergency_drill_tracker",
                  element: <EmergencyDrillTracker />,
                },

            {
                  path: "industrial-identification/asset_and_equipment_inspections",
                  element: <AssetAndEquipmentInspections />,
                },
          ],
        },
    [
      {
            path: "industrial-identification",
            element: <IndustrialIdentificationWithNature />,
          },
      {
            path: "auto-select-ai-sector",
            element: <AutoSelectAISector />,
          },
    ],

    {
          path: "industry-country-specific-standard",
          element: <MainLayout />,
          children: [
            {
                  path: "sector-specific",
                  element: <SectorSpecificStandardCompliances />,
                },

            {
                  path: "sector-specific/sector-standard-compliance",
                  element: <SectorStandardCompliance />,
                },

            {
                  path: "sector-specific/auto-select-ai",
                  element: <AutoSelectAISector />,
                },

            {
                  path: "country-specific-compliance",
                  element: <CountrySpecificCompliance />,
                },

            {
                  path: "country-specific-compliance/canada",
                  element: <Canada />,
                },

            {
                  path: "country-specific-compliance/uae",
                  element: <UnitedArabEmirates />,
                },

            {
                  path: "country-specific-compliance/france",
                  element: <France />,
                },

            {
                  path: "country-specific-compliance/germany",
                  element: <Germany />,
                },

            {
                  path: "country-specific-compliance/italy",
                  element: <Italy />,
                },

            {
                  path: "country-specific-compliance/netherlands",
                  element: <Netherlands />,
                },

            {
                  path: "country-specific-compliance/spain",
                  element: <Spain />,
                },

            {
                  path: "country-specific-compliance/pakistan",
                  element: <Pakistan />,
                },

            {
                  path: "country-specific-compliance/bangladesh",
                  element: <Bangladesh />,
                },

            {
                  path: "country-specific-compliance/nigeria",
                  element: <Nigeria />,
                },

            {
                  path: "country-specific-compliance/singapore",
                  element: <Singapore />,
                },

            {
                  path: "country-specific-compliance/malaysia",
                  element: <Malaysia />,
                },

            {
                  path: "country-specific-compliance/indonesia",
                  element: <Indonesia />,
                },

            {
                  path: "country-specific-compliance/vietnam",
                  element: <Vietnam />,
                },

            {
                  path: "country-specific-compliance/thailand",
                  element: <Thailand />,
                },

            {
                  path: "country-specific-compliance/philippines",
                  element: <Philippines />,
                },

            {
                  path: "country-specific-compliance/auto-select-ai",
                  element: <CountryAutoSelectAI />,
                },

            {
                  path: "operational-compliance-reporting",
                  element: <OperationalCompliaceReporting />,
                },

            {
                  path: "es-due-diligence-compliance",
                  element: <EsDueDiligenceCompliance />,
                },
          ],
        },

    {
          path: "esg",
          element: <MainLayout />,
          children: [
            {
                  path: "verification-module",
                  element: <ESGVerificationModule />,
                },

            {
                  path: "verification-dashboard-module",
                  element: <VerificationDashboard />,
                },
          ],
        },
  ],
};

export default MainRoutes;
